import { RoleRoute } from './RoleRoute';

interface AdminRouteProps {
  children: React.ReactNode;
}

/**
 * Restricts a route to the 'admin' role.
 *
 * Thin wrapper over RoleRoute — kept for backward compatibility with any
 * existing route definitions that reference AdminRoute.
 * Prefer RoleRoute with an explicit allowedRoles prop for new routes.
 *
 * Behaviour: delegates entirely to RoleRoute.
 * - Loading → full-page skeleton
 * - Unauthenticated → /auth
 * - Non-admin → /dashboard + "permission denied" toast
 * - Admin → children rendered
 */
export function AdminRoute({ children }: AdminRouteProps) {
  return <RoleRoute allowedRoles={['admin']}>{children}</RoleRoute>;
}
